import type { TextTitledBodyData } from "@/types/storyboard";

/**
 * Markdown for a structured `{ title, body }` payload.
 * Falls back to `text` when `body` is absent (older stored JSON).
 */
export const titledBodyMarkdown = (data: TextTitledBodyData): string =>
  data.body ?? data.text ?? "";
